import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    dataSource: _ctx.datasource,
    columns: _ctx.columns,
    pagination: _ctx.pageData,
    onChange: _ctx.tableChangeHandle
  }, {
    bodyCell: _withCtx(({ column,text, record }) => [
      (column.key === 'status')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (record.status === 1)
              ? (_openBlock(), _createBlock(_component_a_tag, {
                  key: 0,
                  title: "Enable",
                  color: "#EBF7F2",
                  style: {"color":"#1BAB6F"}
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Enable")
                  ])),
                  _: 1
                }))
              : (record.status === 0)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    title: "Disable",
                    color: "#FAFAFA",
                    style: {"color":"#999999"}
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Disable")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ], 64))
        : (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (record.status === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      onClick: ($event: any) => (_ctx.changeStatus(record))
                    }, "Disable", 8, _hoisted_2)
                  ]))
                : (record.status === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: ($event: any) => (_ctx.changeStatus(record))
                      }, "Enable", 8, _hoisted_4)
                    ]))
                  : _createCommentVNode("", true)
            ], 64))
          : (column.key === 'origincode')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (text === null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "-"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(text), 1))
              ], 64))
            : (column.key === 'origindesc')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (text === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "-"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(text), 1))
                ], 64))
              : (column.key === 'replacecode')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    (text === null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "-"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(text), 1))
                  ], 64))
                : (column.key === 'replacedesc')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      (text === null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "-"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(text), 1))
                    ], 64))
                  : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["dataSource", "columns", "pagination", "onChange"]))
}